export const staticPageThemeOverrides = `
  .tp-static-page {
    --tp-shell-width: 980px;
    --tp-shell-padding-inline: 0px;
    --tp-text-primary: #ffffff;
    --tp-text-muted: rgba(255, 255, 255, 0.72);
    --tp-surface: rgba(255, 255, 255, 0.02);
    --tp-surface-soft: rgba(255, 255, 255, 0.03);
    --tp-border: rgba(255, 255, 255, 0.08);
    --tp-chip-border: rgba(255, 255, 255, 0.22);
    --tp-chip-bg: rgba(255, 255, 255, 0.05);
    --tp-accent: #666dec;
    --tp-accent-soft: rgba(102, 109, 236, 0.24);
    --tp-accent-border: rgba(102, 109, 236, 0.5);
    --tp-link: #66d1ec;
    --tp-progress: 0%;
    width: 100%;
    color: var(--tp-text-primary);
  }

  .tp-static-page .tp-static-shell {
    width: min(var(--tp-shell-width), 100%);
    margin: 0 auto;
    padding-inline: var(--tp-shell-padding-inline);
  }

  .tp-static-page .tp-static-content {
    width: 100%;
  }

  .tp-static-page .tp-static-progress {
    position: sticky;
    top: 60px;
    z-index: 4;
    margin: 0 0 12px;
    height: 2px;
    background: transparent;
  }

  .tp-static-page .tp-static-progress.is-hidden {
    display: none;
  }

  .tp-static-page .tp-static-progress-bar {
    width: var(--tp-progress);
    height: 100%;
    border-radius: 999px;
    background: linear-gradient(90deg, var(--tp-link), var(--tp-accent));
    transition: width 120ms linear;
  }

  .tp-static-page .tp-static-backtop {
    position: fixed;
    right: 18px;
    bottom: calc(env(safe-area-inset-bottom) + 86px);
    z-index: 20;
    border: 1px solid var(--tp-chip-border);
    border-radius: 999px;
    padding: 8px 12px;
    font-size: 0.78rem;
    font-weight: 700;
    background: rgba(10, 15, 28, 0.92);
    color: #dbe4ff;
    opacity: 0;
    transform: translateY(6px);
    pointer-events: none;
    transition: opacity 140ms ease, transform 140ms ease, border-color 140ms ease;
  }

  .tp-static-page .tp-static-backtop.is-hidden {
    display: none;
  }

  .tp-static-page .tp-static-backtop.is-visible {
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
  }

  .tp-static-page .tp-static-backtop:hover {
    border-color: var(--tp-accent-border);
  }

  .tp-static-page .tp-static-anchor {
    margin-left: 8px;
    color: var(--tp-link);
    opacity: 0.78;
    text-decoration: none;
    font-size: 0.78em;
    border-radius: 6px;
    padding: 2px 5px;
    border: 1px solid transparent;
    transition: opacity 120ms ease, border-color 120ms ease, background-color 120ms ease;
  }

  .tp-static-page .tp-static-anchor:hover {
    opacity: 1;
    border-color: var(--tp-accent-border);
    background-color: var(--tp-accent-soft);
  }

  .tp-static-page .tp-static-anchor.is-copied {
    border-color: var(--tp-accent);
    background-color: var(--tp-accent);
    color: #ffffff;
  }

  .tp-static-page :is(h2, h3, h4) {
    scroll-margin-top: 102px;
  }

  .tp-static-page :is(a, button, [role='button']):focus-visible {
    outline: 2px solid var(--tp-accent);
    outline-offset: 2px;
  }

  @media (max-width: 768px) {
    .tp-static-page {
      --tp-shell-padding-inline: 0px;
    }

    .tp-static-page .tp-static-progress {
      top: 56px;
    }

    .tp-static-page .tp-static-backtop {
      right: 10px;
      bottom: calc(env(safe-area-inset-bottom) + 82px);
      padding: 7px 10px;
      font-size: 0.74rem;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .tp-static-page * {
      animation: none !important;
      transition: none !important;
      scroll-behavior: auto !important;
    }
  }
`;

export const mergeStaticPageOverrides = (...styles: Array<string | undefined>) =>
  styles
    .map((style) => style?.trim())
    .filter(Boolean)
    .join('\n');
